define([
	"dojo/_base/declare",
	"csi/reflection",
	"csi/table/Copy",
	"csi/xml",
	"Apparel/model/productSource",
	"./ProductType"
], function(declare, reflection, Copy, xml, {SAMPLE_TO_PRODUCT_PATH}, ProductType) {

	return declare(Copy, {
		idOwnerRelation: "Samples",

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set the product on copy form
			this.inherited(arguments);

			const product = this.m_cache.getPathNode(this.getNode(), SAMPLE_TO_PRODUCT_PATH);
			view.setProduct?.(product);

			if (product?.$Type == "Material") {
				// Clears Sample Field when copying a Sample
				this.m_formData.setFieldInitialValue(xml.ATTR_NAME, "");
				// there is no view controller for Material - see if we should hide Colors / Sizes fields
				var colorsField = view.getField("ProductColor");
				var sizesField = view.getField("ProductSize");

				if (colorsField && !ProductType.hasColor(product))
					colorsField.bHidden = true;
				if (sizesField && !ProductType.hasSize(product))
					sizesField.bHidden = true;
			}
		},

		/**
		 * @override
		 * Add path to parent product and path to access
		 * supplier and SampleFactory nodes since its not in cache 
		 */
		onDependencyPaths(paths) {
			paths.push(SAMPLE_TO_PRODUCT_PATH);
			paths.push("Child:__Parent__/Child:Supplier");
			paths.push("Child:SampleFactory");
		},

		_toWriterParent: function() {
			// DE26722	add sample to product source as system
			var owner = this.idOwnerRelation ? this.m_cache.getNode(this.urlOwnerParent, true) : null;
			const copySampleName = this.generateSampleName();

			if (owner) {
				var relation = reflection.getRelation(owner, this.idOwnerRelation);
				if (relation) {
					var parent = this.getParent();
					if (parent.$Type == "SampleStorage") {
						//DE27903
						this.m_writer
							.callMethod("Sourcing", "ProductSourceAddSampleStorageSample")
							.addParameter("URL", xml.ATTR_REF, this.urlOwnerParent)
							.addParameter("SampleStorageURL", xml.ATTR_REF, parent.$URL)
							.addParameter("SampleURL", xml.ATTR_REF, this.m_value);
					} else if (
						parent.$Type === "SupplierRequest" &&
						(parent.RequestType === "DataPackageContainerType:Food" ||
							parent.RequestType === "DataPackageContainerType:FormulatedMaterial" ||
							parent.RequestType === "DataPackageContainerType:FoodSKU")
					) {
						this.m_writer
							.callMethod("FormulatedProduct", "FoodSourceAddSample")
							.addParameter("URL", xml.ATTR_REF, this.urlOwnerParent)
							.addParameter("SampleURL", xml.ATTR_REF, this.m_value);
					} else {
						this.m_writer
							.callMethod("Sourcing", "ProductSourceAddSample")
							.addParameter("URL", xml.ATTR_REF, this.urlOwnerParent)
							.addParameter("SampleURL", xml.ATTR_REF, this.m_value)
							.addParameter("Name", xml.ATTR_STRING, copySampleName);
					}
				}

				// see if there was a CopySampleBOM option and if it was checked.  if so, run copy sample BOM
				var copySampleBOMField = this.m_formData.getField("CopySampleBOM");
				if (copySampleBOMField && copySampleBOMField.getValue()) {
					this.m_writer.callMethod("Specification", "CopySampleBOM")
						.addParameter("FromURL", xml.ATTR_REF, this.m_nodeSource.$URL)
						.addParameter("URL", xml.ATTR_REF, this.m_value)
				}
			}
		},

		generateSampleName(){
			const { m_cache } = this;
			const fd = this.m_formData;
			var owner = this.idOwnerRelation ? m_cache.getNode(this.urlOwnerParent, true) : null;
			const sourceURL = xml.isValidURL(owner.SupplierFactory);
			const sample = this.m_nodeSource;
			const factoryURL = sample.SampleFactory;
			const factoryNode = m_cache.getNode(factoryURL);
			const sourceNode = sourceURL ? factoryNode : m_cache.getNode(owner.Supplier);
			const sourceName = sourceNode.$Name;
			const prefix = fd.getFieldValue(xml.ATTR_NAME) == "" ? sourceName : fd.getFieldValue(xml.ATTR_NAME, true) + " - " + sourceName;
			const colorURL = fd.getFieldValue("ProductColor");
			const infix = xml.isValidURL(colorURL) ? prefix + "-" + m_cache.getNode(colorURL).$Name : prefix;
			const sizeURL = fd.getFieldValue("ProductSize");
			const suffix = xml.isValidURL(sizeURL) ? infix + "-" + m_cache.getNode(sizeURL).$Name : infix;

			return suffix;
		}

	});
});